<template>
    <BaseModal
        :id="'static-move'"
        :title="title"
        :message="'Are you sure you want to move the selected room(s)?'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                  :form_format="form_format"
                  :form_data="form_data"
                  :array_options="array_options"
                  :for_update="false"
                />
                <p class="modal__description__text mt-2" v-if="form_data.for_today_only">The room(s) will return back to its original assignment in the specified hours.</p>
                <div class="formdynamic__item py-0 px-0 col-md-4 mb-3 mt-2"  v-if="form_data.for_today_only">
                    <div class="formdynamic__item__field">
                        <label for="Hours" class="modal-label active">Hours</label>
                        <input placeholder="" step=".1" min="1" max="24" type="number" v-model="form_data.hours">
                    </div>
                </div>
                <div class="mt-3">
                    <label class="black-label" for="" v-html="`Minutes To Move: ${minutes_move} Min`"></label>
                </div>
                <div class="mt-3">
                    <label class="black-label" for="" v-html="`New Assignment Current Total: ${form_data.daily_assignment_id ? numberStringFormat(new_current_total, 1) : 0} Min`"></label>
                </div>
                <div class="mt-3">
                    <label class="black-label" for="" v-html="`New Assignment Total After Move: ${form_data.daily_assignment_id ? numberStringFormat(minutes_move + new_current_total, 1) : 0} Min`"></label>
                </div>
                <div v-if="total_minutes" class="mt-3">
                    <label class="black-label" for="" v-html="`This Assignment Total After Move: ${total_after_move()} Min`"></label>
                </div>
                <div class="modal__buttons text-center text-md-right">
                    <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'"/>
                    <button class="modal__buttons__item" v-html="`Confirm Move`"/>
                </div>
            </form>
        </template>
    </BaseModal>
</template>

<style scoped>
    .black-label{
        color:black;
    }
</style>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'

export default {
  name: "FormModalMove",
  props: [
    "title",
    "rest_api",
    "notyf",
    "array_options",
    "breadcrumb",
    "parent_id",
    "rooms",
    "total_minutes",
    "permission_move",
    "daily_assignments_collection"
  ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
    },

    computed:{

        minutes_move()
        {
            return this.sumArrays(this.rooms.map(item => item.minutes), true)
        },

    },

    data(){
        return{
            form_data: FormResources.form_data_move,
            form_format: FormResources.form_format_move,
            form_backup: {...FormResources.form_data_move},
            new_current_total: 0,
        }
    },

    watch: {

        rooms(val)
        {
            if(val)
            {
                this.form_data.rooms = val;
            }
        },

        'form_data.daily_assignment_id'(val)
        {
            if(val)
            {
                let minutes = this.array_options.daily_assignment_id.find(item => item.id == val).minutes
                this.new_current_total = this.sumArrays(minutes, true)
            }
        },

        'permission_move'(val)
        {
            if(val == 3)
            {
                this.form_data.for_today_only = true
                this.form_format[1].disabled = true
                return
            }
            
            if(val == 2)
            {
                this.form_format[1].disabled = true
            }

            this.form_data.for_today_only = false
        }

    },

    methods: {

        async form_submit() 
        {
            const json_request = {
                id: this.parent_id,
                requirement: 'move_rooms',
            }

            this.loader(true)

            const response  = await this.patch(`${this.rest_api}/${JSON.stringify(json_request)}`, this.form_data)

            if(response.status)
            {
                this.$emit('move', true);
                this.loader()
                window.$('#static-move').modal('hide')
                this.form_data = {...this.form_backup}
            }
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        total_after_move()
        {
            return parseFloat(Number(this.total_minutes) - this.minutes_move).toFixed(2)
        },

    },

  mounted() {},

};
</script>